module.exports = __webpack_public_path__ + "src/assets/textures/env/wagon/wagon_rear_left_wheel_512_bake.png";